import { fetchStatuses } from '../../api';

const state = {
  list: [],
};

const getters = {
  statuses: ({ list }) => list,
  statusById: ({ list }) => list.reduce((acum, item) => ({
    ...acum,
    [item.id]: item.name,
  }), {}),
};

const actions = {
  loadStatuses({ commit }) {
    fetchStatuses()
      .then((res) => {
        commit('setStatuses', res);
      });
  },
};

const mutations = {
  // eslint-disable-next-line
  setStatuses(state, payload) {
    // eslint-disable-next-line
    state.list = payload;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
